import { Modal, Button, Spinner } from "flowbite-react";
import { useTranslation } from "react-i18next";

interface ConfirmationDialogProps {
  title: string;
  body: string;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

function ConfirmationDialog({
  title,
  body,
  onCancel,
  onConfirm,
  isLoading = false,
}: ConfirmationDialogProps) {
  const { t } = useTranslation(["common"]);

  return (
    <Modal show={true} onClose={onCancel}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <p className="text-gray-700 dark:text-gray-400">{body}</p>
      </Modal.Body>
      <Modal.Footer className="flex justify-end">
        <Button color="gray" onClick={onCancel} disabled={isLoading}>
          {t("common:cancel")}
        </Button>
        <Button color="failure" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? (
            <div className="flex items-center">
              <Spinner size="sm" className="mr-2" />
              {t("common:processing")}
            </div>
          ) : (
            t("common:confirm")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationDialog;
